<template>
  <div class="row">
    <div class="col-lg-12">
      <img :src="logo" alt="Icon Ecard" class="logo" />
      <form>
        <div class="form-group mt-3">
          <input type="text" class="form-control" id="inputNome" aria-describedby="nameHelp"
            :placeholder="translate.labelName" name="name" v-model="form.nome" />

          <input type="email" class="form-control" id="inputEmail" aria-describedby="emailHelp"
            :placeholder="translate.labelEmail" name="email" v-model="form.email" />

          <input type="text" class="form-control" id="inputNameRecipiment" aria-describedby="nameRecipientName"
            :placeholder="translate.labelRecipientName" name="nameRecipientName" v-model="form.nomeDestinatario" />

          <input type="email" class="form-control" id="inputEmailRecipiment" aria-describedby="emailRecipiment"
            :placeholder="translate.labelEmailRecipient" name="emailRecipiment" v-model="form.emailDestinatario" />

          <input type="text" class="form-control" id="inputMessage" aria-describedby="messageHelp"
            :placeholder="translate.labelMessage" name="message" v-model="form.mensagem">
        </div>
        <div class="col-lg-6 col-12 d-w-btn mt-4">
          <button>{{ translate.button }} <i class="icon-arrow-right"></i></button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import modelsTradutor from 'tradutors/ecards'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import iconeEcard from 'assets/img/icone-ecard.png'

export default defineComponent({
  name: 'EcardForm',
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function () {
      if (this.locale === 'pt-br') {
        return modelsTradutor.portugues
      } else {
        return modelsTradutor.ingles
      }
    }
  },
  data() {
    return {
      form: {
        email: '',
        nome: '',
        nomeDestinatario: '',
        emailDestinatario: '',
        mensagem: ''
      },
      logo: iconeEcard
    }
  }
})
</script>

<style lang="css" scoped>
.logo {
  height: 88px;
}

.form-group input {
  padding: 15px 20px;
  border-radius: 30px;
  margin-bottom: 15px;
  background-color: #f8f8f8;
  font-size: small;
}

.input-group-text {
  padding: 0;
  padding-left: 5px;
  font-size: 2rem;
  background-color: #f8f8f8;
  border: 1px solid #ced4da;
  border-radius: 30px;
  border-left-style: hidden;
  height: 51px;
}

.d-w-btn button {
  color: #fff;
  padding: 5px;
}

.d-w-btn {
  background: #000;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.d-w-btn i {
  font-size: 20px;
}
</style>
